// <CategoryAdBanner> -- a category's advertising banner (My Global Pub).
// When Family chose an Elakay Swiper for the category (a SwiperPlacement in
// slot "banner"), that swiper is drawn -- slides, animations, links,
// responsive settings, exactly as built in the Swiper Studio -- where the
// category's pub slider is. Otherwise the historical image slider
// (`children`) is kept, untouched. Same cached page request as the page's
// other swipers (DynamicPageRenderer), so no extra call on category pages.
import React, { useMemo } from "react";
import { elakayAutoText } from "../pageInside/dataElakay";
import { usePageDynamicSwipers } from "./PageDynamicSwipers";
import { SLOT_BANNER } from "./dynamicSwiperRegistry";
import DefaultCategorySwiper from "../defaultPromo/DefaultCategorySwiper";
import DynamicSwiper from "./DynamicSwiper";

const CategoryAdBanner = ({ categoryId, children = null, ownImages = [], swiperOptions }) => {
  const page = useMemo(() => (categoryId ? { pageType: "category", categoryId: String(categoryId) } : null), [categoryId]);
  const placements = usePageDynamicSwipers(page);
  const banner = placements.find((placement) => placement.slotKey === SLOT_BANNER && placement.swiper);
  if (!banner) {
    const hasOwnImages = Array.isArray(ownImages) && ownImages.some((image) => typeof image?.urlImg === 'string' && image.urlImg.trim() && !/loading3\.gif/.test(image.urlImg));
    if (!categoryId || hasOwnImages) return children;
    return <DefaultCategorySwiper categoryId={categoryId} swiperOptions={swiperOptions}>{children}</DefaultCategorySwiper>;
  }
  return (
    <div className="dsw-slot dsw-banner" data-dsw-slot={SLOT_BANNER}>
      <DynamicSwiper swiper={banner.swiper} eager label={elakayAutoText("h_dsw_banner_label", "Advertising")} />
    </div>
  );
};

export default CategoryAdBanner;
